import Box from '@mui/material/Box';

import SearchSectionSelect from '@/components/common/searchSection/SearchSectionSelect';
import type { SearchOption } from '@/components/common/searchSection/types';

type SearchFilterRowProps = {
	idPrefix: string;
	filterTyp: string;
	filterThema: string;
	typOptions: SearchOption[];
	themaOptions: SearchOption[];
	onFilterTypChange: (value: string | null) => void;
	onFilterThemaChange: (value: string | null) => void;
};

const SearchFilterRow = ({
	idPrefix,
	filterTyp,
	filterThema,
	typOptions,
	themaOptions,
	onFilterTypChange,
	onFilterThemaChange
}: SearchFilterRowProps) => (
	<Box
		sx={{
			display: 'grid',
			gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
			gap: 4,
			width: '100%'
		}}
	>
		<SearchSectionSelect
			id={`${idPrefix}-typ`}
			value={filterTyp}
			placeholder="Typ"
			options={typOptions}
			onChange={onFilterTypChange}
			appearance="overlay"
			sx={{ minWidth: 0 }}
		/>
		<SearchSectionSelect
			id={`${idPrefix}-thema`}
			value={filterThema}
			placeholder="Thema"
			options={themaOptions}
			onChange={onFilterThemaChange}
			appearance="overlay"
			sx={{ minWidth: 0 }}
		/>
	</Box>
);

export default SearchFilterRow;
